/**
 * Outveil: mirrors the desktop :hover state on touch devices for two
 * things on a product card - the secondary-image swap, and the quick-add
 * "+" button's reveal. Touching a card shows both for as long as the
 * finger stays down; lifting or cancelling the touch reverts them. A
 * single delegated listener, no per-card wiring needed.
 */
(function () {
  var activeMedia = null;
  var activeCard = null;

  function clearActive() {
    if (activeMedia) {
      activeMedia.classList.remove('is-touch-active');
      activeMedia = null;
    }
    if (activeCard) {
      activeCard.classList.remove('quick-add-touch-active');
      activeCard = null;
    }
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      var media = event.target.closest && event.target.closest('.media.media--hover-effect');
      var card = event.target.closest && event.target.closest('.card-wrapper');
      if (media === activeMedia && card === activeCard) return;
      clearActive();
      // Inside a swipeable slider, a touch is the start of a horizontal
      // drag, not a hold-to-preview gesture: leave the secondary-image
      // swap alone so its zoom transition doesn't fight the slider's
      // swipe handling. The quick-add button's reveal is just an opacity
      // fade with no transform, so it's safe to show it even there.
      if (media && !media.closest('.slider')) {
        media.classList.add('is-touch-active');
        activeMedia = media;
      }
      if (card) {
        card.classList.add('quick-add-touch-active');
        activeCard = card;
      }
    },
    { passive: true }
  );

  document.addEventListener('touchend', clearActive, { passive: true });
  document.addEventListener('touchcancel', clearActive, { passive: true });
})();
